import { Accordion, AccordionDetails, AccordionSummary, WithStyles } from "@material-ui/core";
import React, { useState } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography/Typography";
import { styles } from "./TableAccordionElement.styles";

export interface TableAccordionElementProps extends WithStyles<typeof styles> {
    rowId: number;
    labelCollapsed: string;
    detailElementUncollapsed: any;
}

const TableAccordionElementPure: React.FunctionComponent<TableAccordionElementProps> = ({rowId, labelCollapsed, detailElementUncollapsed, classes}: TableAccordionElementProps) => {
    const [expandedRow, setExpandedRow] = useState(-1);

    function isExpanded(rowId) {
        return rowId === expandedRow;
    }

    const manageRowAccordion = (rowId) => {
        const isExpandedNow = rowId === expandedRow;
        const newExpandedRowId = isExpandedNow ? -1 : rowId;
        setExpandedRow(newExpandedRowId);
    };

    return <Accordion variant="outlined" expanded={isExpanded(rowId)}
                      onChange={() => manageRowAccordion(rowId)}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
            <Typography variant={"h4"}>{labelCollapsed}</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.details}>
            {detailElementUncollapsed}
        </AccordionDetails>
    </Accordion>;
}

export const TableAccordionElement = withStyles(styles)(TableAccordionElementPure);
